import { FC, memo, useCallback } from "react";
import { InputText, Select } from "#/atoms";
import { getBoleanFromYesOrNo, getYesOrNo } from "@/helpers";
import { useInput, useSelect } from "@/hooks";

import { FilterSidebar } from "#/molecules";
import { FilterWorkersProps } from "./Workers.interface";

const Workers: FC<FilterWorkersProps> = ({ filter, numberOfFilters, onCloseFilter, onClearFilter, onFilter }) => {
  const active = useSelect(getYesOrNo(filter?.active));
  const name = useInput(filter?.name);
  const type = useInput(filter?.type);
  const email = useInput(filter?.email);
  const location = useInput(filter?.location);

  const handleFilter = useCallback(() => {
    onFilter({
      active: getBoleanFromYesOrNo(active.value),
      email: email.value,
      location: location.value,
      name: name.value,
      type: type.value,
    });
  }, [active, name, type, email, location]);

  return (
    <FilterSidebar
      numberOfFilters={numberOfFilters}
      onClearFilters={onClearFilter}
      onClose={onCloseFilter}
      onFilter={handleFilter}
    >
     <InputText type="text" label="Display Name" fullWidth value={name.value} onChange={name.onChange} />
      <InputText type="text" label="E-mail Address" fullWidth value={email.value} onChange={email.onChange} />
      <InputText type="text" label="Postcode" fullWidth value={location.value} onChange={location.onChange} />
      <InputText type="text" label="Work Type" fullWidth value={type.value} onChange={type.onChange} />
      <Select
        label="Is Active"
        selected={active.value}
        options={[
          { id: '', label: '' },
          { id: 'no', label: 'No' },
          { id: 'yes', label: 'Yes' },
        ]}
        onChange={active.onChange}
      />
    </FilterSidebar>
  );
}

export default memo(Workers);
